import { Button, CircularProgress, Dialog, DialogActions, DialogContent, Divider, IconButton, MenuItem, Switch, TextField } from "@mui/material";
import { Component } from "react";
import DialogTitleWithCloseButton from "../../../components/DialogTitleWithCloseButton";
import PillLabel from "../../../components/PillLabel";
import SearchIcon from '@mui/icons-material/Search';
import { AGENT_TYPE, DOCUMENT_NAME } from "../../../../../shared/constants";
import { errorToast } from "../../../toast";
import request from "../../../request";
import swal from "sweetalert";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import EditIcon from '@mui/icons-material/Edit';
import AttachmentInput from "../../../components/AttachmentInput";
import { showLoading, hideLoading } from "../../../loading";
import SearchAgent from "../SearchAgent";
import SearchProduct from "../SearchProduct";
import { LOAN_TENURE_OPTIONS } from "../../../constants";
import { getCustomerFullName } from "../../../../../shared/utils";
import CustomerForm from "../../../components/CustomerForm";
import { EventEmitter } from "events";

// helpers
function createAttachmentObject(name) {
   return {
      name,
      fileName: '',
      base64: '',
      ext: '',
   }
}


export default class RecordLoan extends Component {

   eventBus = new EventEmitter();

   state = {
      isNewCustomer: false,
      isCustomerACompany: false,
      searchingCustomer: false,
      searchedCustomer: null,
      loanAttachments: Object
         .values(DOCUMENT_NAME.LOAN)
         .filter(name => name !== DOCUMENT_NAME.LOAN.CONTRACT)
         .map(createAttachmentObject),
      products: [],
      agents: [],
      tenure: '',
      agent: '',
      product: '',
   }

   search = async () => {
      const txtSearch = document.getElementById('txt-search-customer');
      const email = txtSearch.value.toUpperCase().trim();

      if (!email) {
         errorToast("Please enter a valid national ID");
         return txtSearch.focus();
      }

      try {

         this.setState({ searchingCustomer: true });

         const params = { email };
         const res = await request.get("/api/general/customers/search", { params});

         const searchedCustomer = res.data;
         const isCustomerACompany = searchedCustomer.is_company;
         await this.updateState({ searchedCustomer, isCustomerACompany });

      } catch (err) {
         swal("Error", err.message, "error");
      } finally {
         this.setState({ searchingCustomer: false });
      }

   }

   getCustomerFromForm() {
      return new Promise((resolve) => {
         this.eventBus.emit(CustomerForm.SUBMIT_EVENT, customer => {
            resolve(customer);
         });
      });
   }

   submit = async () => {
      // extract
      const txtProduct = document.getElementById('txt-product');
      const txtPrice = document.getElementById('txt-price');
      const txtDeposit = document.getElementById('txt-deposit');
      const txtTenure = document.getElementById('txt-tenure');

      const { isNewCustomer, searchedCustomer, loanAttachments, product, tenure, agent } = this.state;
      const price = txtPrice.value;
      const deposit = txtDeposit.value;

      // validate
      let customer
      if (isNewCustomer) {

         customer = await this.getCustomerFromForm();
         if (!customer)
            return;

         customer.is_new = true;

      } else {
         if (!searchedCustomer) {
            errorToast("Please search for the customer");
            return;
         }

         customer = {
            is_new: false,
            _id: searchedCustomer._id,
         };
      }

      console.log(customer);

      if (!product) {
         errorToast("Please select the product");
         return txtProduct.focus();
      }

      if (!price) {
         errorToast("Please enter the negotiated price");
         return txtPrice.focus();
      }

      if (!deposit) {
         errorToast("Please enter the deposit amount");
         return txtDeposit.focus();
      }

      if (!tenure) {
         errorToast("Please select the tenure");
         return txtTenure.focus();
      }

      for (let attachment of loanAttachments) {
         if (!attachment.base64) {
            errorToast(`Please attach ${attachment.name}`);
            return;
         }
      }

      try {
         showLoading();

         const data = {
            customer,
            product: product._id,
            price,
            deposit,
            tenure,
            attachments: loanAttachments
               .map(({ name, base64, ext }) => ({ name, base64, ext }))
         }

         if (agent)
            data.agent = agent._id;

         const res = await request.post("/api/sales/loans", data);
         this.props.onClose(res.data);
         
         swal("Success", "Loan recorded successfully", "success");

      } catch (err) {
         swal("Error", err.message, "error");
      } finally {
         hideLoading();
      }

   }

   componentDidUpdate(_, prevState) {
      // remove/add payslip attachment based on {isCustomerACompany}
      if (this.state.isCustomerACompany !== prevState.isCustomerACompany) {
         if (this.state.isCustomerACompany) {
            const loanAttachments = this.state.loanAttachments.filter(a => a.name !== DOCUMENT_NAME.LOAN.PAYSLIP);
            this.setState({ loanAttachments });
         } else {
            const payslipAttachment = createAttachmentObject(DOCUMENT_NAME.LOAN.PAYSLIP);
            this.setState(prevState => ({
               loanAttachments: [...prevState.loanAttachments, payslipAttachment]
            }));
         }
      }

      // if {isNewCustomer} is changed, remove the searched customer
      // and set {isCustomerACompany} to false
      if (this.state.isNewCustomer !== prevState.isNewCustomer) {
         this.setState({
            searchedCustomer: null,
            isCustomerACompany: false,
         });
      }
   }

   componentDidMount() {
      this.eventBus.on(CustomerForm.CHANGE_EVENT, data => {
         if (typeof data.is_company === 'boolean') {
            this.setState({ isCustomerACompany: data.is_company });
         }
      });
   }

   render() {

      let customerForm;

      if (this.state.isNewCustomer) {
         customerForm = <div className="col-span-full">
            <CustomerForm
               eventBus={this.eventBus}
            />
         </div>
      } else {

         if (this.state.searchedCustomer) {

            customerForm = <div className="grid grid-cols-[auto,1fr,auto] gap-2 col-span-2">
               <div className="text-gray-400 text-6xl">
                  <AccountCircleIcon fontSize="inherit"  />
               </div>
               <div className="flex items-center">
                  <div>
                     <div className="font-bold">
                        {getCustomerFullName(this.state.searchedCustomer)}
                     </div>
                     <div className="text-gray-500 truncate">
                        {this.state.searchedCustomer.email}
                     </div>
                  </div>
               </div>
               <div className="flex items-center">
                  <IconButton onClick={() => this.setState({ searchedCustomer: null })}>
                     <EditIcon />
                  </IconButton>
               </div>
            </div>
         } else {
            customerForm = <div className="grid grid-cols-[1fr,auto] col-span-2 rounded-lg overflow-hidden">
               <input
                  id="txt-search-customer"
                  placeholder="Search by email"
                  type="search"
                  className="outline-none border-[1px] px-2"
               />

               <IconButton
                  className="bg-orange-600 text-white rounded-none aspect-square"
                  onClick={this.search}
                  disabled={this.state.searchingCustomer}
               >
                  {this.state.searchingCustomer ? <CircularProgress size={24} color="white" /> : <SearchIcon />}
               </IconButton>
            </div>
         }

      }

      return <Dialog open fullWidth maxWidth="sm">
         <DialogTitleWithCloseButton onClose={this.props.onClose}>
            Record Loan
         </DialogTitleWithCloseButton>

         <DialogContent className="p-0" dividers>
            <div className="text-gray-600 aspect-square overflow-y-auto overflow-x-hidden p-4">
               <div className="grid grid-cols-2 [&>*]:mt-2 gap-4">
                  
                  <div className="flex items-center">
                     <PillLabel>Customer Info</PillLabel>
                  </div>

                  <div className="text-sm flex items-center">
                     <Switch
                        checked={this.state.isNewCustomer}
                        onChange={e => this.setState({ isNewCustomer: e.target.checked })}
                     /> Is new customer  
                  </div>

                  {customerForm}

               </div>

               <Divider className="my-4" />

               <div>
                  <PillLabel>Loan Info</PillLabel>

                  <div className="grid grid-cols-2 gap-4 mt-4">
                     <SearchProduct
                        id="txt-product"
                        label="Product"
                        size="small"
                        onChange={product => this.setState({ product }) }
                        value={this.state.product}
                     />

                     <SearchAgent
                        id="txt-agent"
                        label="Agent"
                        size="small"
                        onChange={agent => this.setState({ agent }) }
                        value={this.state.agent}
                        type={AGENT_TYPE.SALES}
                     />

                     <TextField
                        id="txt-price"
                        label="Negotiated Price"
                        variant="outlined"
                        size="small"
                        fullWidth
                        type="number"
                     />

                     <TextField
                        id="txt-deposit"
                        label="Deposit"
                        variant="outlined"
                        size="small"
                        fullWidth
                        type="number"
                     />

                     <TextField
                        id="txt-tenure"
                        label="Tenure"
                        variant="outlined"
                        size="small"
                        fullWidth
                        onChange={e => this.setState({ tenure: e.target.value })}
                        value={this.state.tenure}
                        select
                     >
                        {
                           LOAN_TENURE_OPTIONS.map(tenure => {
                              return <MenuItem key={tenure} value={tenure}>
                                 {tenure} months
                              </MenuItem>
                           })
                        }
                     </TextField>
                  </div>

                  <div className="grid grid-cols-1 gap-4 mt-4">
                     {
                        this.state.loanAttachments.map((attachment, index) => {
                           return <AttachmentInput
                              key={index}
                              label={attachment.name}
                              name={attachment.fileName}
                              onChange={({ name, base64, ext }) => {
                                 const attachments = this.state.loanAttachments.map(a => {
                                    if (a === attachment)
                                       return { ...a, fileName: name, base64, ext };
                                    return a;
                                 });
                                 this.setState({ loanAttachments: attachments });
                              }}
                           />
                        })
                     }
                  </div>

               </div>
            </div>
         </DialogContent>

         <DialogActions>
            <Button variant="contained" onClick={this.submit}>
               SUBMIT
            </Button>
         </DialogActions>
      </Dialog>
   }
}